import AxiosService from "./axiosServices";

const axiosService = new AxiosService();

export default class ApplicationConfigsService {
  saveAdminApprovalConfig = (data) => {
    return axiosService.Post("api/approval-settings/", data);
  };

  getAdminApprovalConfig = () => {
    return axiosService.Get("api/approval-settings/");
  };

  // The component loads the complete list and applies search/filtering locally.
  getDrugTypes = () => {
    return axiosService.Get("api/drug-types/");
  };

  createDrugType = (payload) => {
    const data = {
      body: {
        ...payload,
      },
    };

    return axiosService.Post("api/create-drug-type/", data);
  };

  updateDrugTypeApproval = (id, data) => {
    return axiosService.Patch(`api/drug-types/${id}/approval-settings/`, data);
  };

  saveDrugTypeApprovalSettings = (payload) => {
    const data = {
      body: [...payload],
    };
    return axiosService.Put("api/create-drug-type/", data);
  };
}
